<!-- adapted from https://george-hadjigeorgiou97.medium.com/step-by-step-custom-drag-drop-upload-component-in-vuetify-vue-2-43c99794643d -->
<template>
    <v-card
        @drop.prevent="onDrop($event)"
        @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true"
        @dragleave.prevent="dragover = false"
        :class="{ 'grey lighten-2': dragover }"
        class="d-flex flex-column"
    >
        <v-card-text>
            <v-row class="d-flex flex-column" justify="center">
                <v-alert
                    v-if="errorText"
                    color="error"
                    icon="$alert"
                    title="Error"
                    closable
                    @dismiss="errorText = ''"
                >
                    {{ errorText }}
                </v-alert>
            </v-row>
            <v-row class="d-flex flex-column mb-4" align="center" density="compact">
                <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60" style="color: gray">
                    $cloud-upload
                </v-icon>
                <p style="align-self: center; color: gray">Drop your file(s) here.</p>
            </v-row>
            <v-virtual-scroll
                v-if="uploadedFiles.length > 0"
                :items="uploadedFiles"
                height="150"
                item-height="50"
            >
                <template v-slot:default="{ item }">
                    <v-list-item :key="item.name" class="d-flex align-center">
                        <div class="d-flex justify-space-between align-center" style="width: 100%">
                            <v-list-item-title class="text-truncate" style="width: 95%">
                                {{ item.name }}
                                <span class="ml-3 text--secondary">{{ item.size }} bytes</span>
                            </v-list-item-title>
                            <v-list-item-action>
                                <v-icon end @click.stop="removeFile(item.name)" style="color: gray">
                                    $close-circle
                                </v-icon>
                            </v-list-item-action>
                        </div>
                    </v-list-item>
                    <v-divider></v-divider>
                </template>
            </v-virtual-scroll>
        </v-card-text>
        <v-spacer></v-spacer>
    </v-card>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        acceptedFileTypes: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            dragover: false,
            uploadedFiles: [],
            errorText: "",
        };
    },

    methods: {
        removeFile(fileName) {
            // Find the index of the file to be removed
            const index = this.uploadedFiles.findIndex((file) => file.name === fileName);

            // Remove the file from the array of uploaded files
            this.uploadedFiles.splice(index, 1);

            this.notifyParent();
        },

        onDrop(e) {
            this.dragover = false;
            this.errorText = "";

            // If there are already uploaded files remove them
            if (this.uploadedFiles.length > 0) {
                this.uploadedFiles = [];
            }

            // Add each file to the array of uploaded files
            for (let i = 0; i < e.dataTransfer.files.length; i++) {
                this.uploadedFiles.push(e.dataTransfer.files[i]);
            }

            if (this.acceptedFileTypes.length > 0) {
                // Check if the uploaded files are of the accepted file types
                this.uploadedFiles.forEach((file) => {
                    if (!this.acceptedFileTypes.includes(file.type)) {
                        // If file type is not supported, display error message
                        this.errorText = "File type not supported";
                        this.uploadedFiles = [];
                    }
                });
            }

            this.notifyParent();
        },

        notifyParent() {
            this.$emit("filesUploaded", this.uploadedFiles);
        },
    },
});
</script>
